Vue.filter(
	'nl2br',
	function (value) {
		return value.replace(new RegExp('\n', 'g'), '<br>');
	}
)

Vue.directive('blink', {})
import multiselectData from './mixins/multiselect';
import SelectionLang from './mixins/trans';

Vue.mixin(multiselectData);
Vue.mixin(SelectionLang);

import store from './store/store';

const app = new Vue({
	el: '#app',
	delimiters: ['${', '}'],
	store,
	data() {
		return {
			loaded: false,
			prompt_message_modal: false,
			modal_message_parameters: {
				modal_title: '',
				modal_title_text_color: '',
				modal_message: '',
				modal_type: 'danger',
			},
			ajax_xhr: '',
			show_shortcut_quick_add: false,
			show_user_guide_modal: false,
			show_news_modal: false,
			dismiss_new_updates: typeof window.dismiss_new_updates !== 'undefined' ? (window.dismiss_new_updates === true || window.dismiss_new_updates === 'true') : false,
			disable_template_responsive: false,
            show_year_transition_confirm: false,
			ajax_sequence_queue_get_records: [],
			ajax_sequence_queue_post_records: [],
			ajax_sequence_submitting: false,
			unique_page_id: null,
			year_transition_status : {
				year_enabled : false,
				next_term : false,
				next_class : false,
				next_student_promote : false,
				next_new_student : false,
				next_new_staff : false,
				next_staff_position : false,
				next_staff_attendance : false,
				next_year_calendar_event : false,
				next_year_admission_fee_setting : false,
				next_year_application_fee_setting : false,
				next_new_tuition : false,
				next_student_important_document : false,
			},
		}
	},
	methods: {
		search: _.debounce((event) => {
			store.commit('setFilterKeywordViaEvent', event);
		}, store.getters.debounceMS),
		filter(event, filter) {
			store.commit('setFilterViaEvent', {filter, event});
		},
		toggleMenu() {
			store.commit('toggleMenuTransitioning');
			store.commit('toggleMenuShow');
			// axios.post('/api/user-preference/menu', {show: store.state.menu.show})
			//     .then(res => {
			//         console.log(res.data);
			//     })
			//     .catch(error => {
			//         store.commit('setNotificationType', 'warning');
			//         store.commit('setNotification', 'Slow down');
			//     })
			store.commit('toggleMenuTransitioning');
			this.$nextTick(function() {
				window.eventHub.$emit('side-menu-resize');
			});
		},
		emit(eventName, para = undefined) {
			window.eventHub.$emit(eventName, para)
		},
		EventOn(eventName, method) {
			window.eventHub.$on(eventName, method);
		},
		EventOff(eventName, callback) {
			window.eventHub.$off(eventName, callback);
		},
		closeNewsModal() {
			this.ajax_post(
				'/user-preference/dismiss-new-updates',
				{ dismiss: this.dismiss_new_updates },
				() => { this.show_news_modal = false; },
				() => { this.show_news_modal = false; },
				false
			);
		},
		ajax_post(url, formData, successCallback, failCallback, cancelPreviousCall, request_config)
		{
			let method = 'post';
			this.ajax_call(url, method, formData, successCallback, failCallback, cancelPreviousCall, request_config);
		},
		ajax_patch(url, formData, successCallback, failCallback, cancelPreviousCall, request_config)
		{
			let method = 'post';
			if (formData instanceof FormData) {
				formData.append('_method', 'patch');
			} else if (typeof formData == 'object') {
				formData._method = 'patch';
			} else {
				formData = { _method: 'patch' };
			}
			this.ajax_call(url, method, formData, successCallback, failCallback, cancelPreviousCall, request_config);
		},
		ajax_delete(url, formData, successCallback, failCallback, cancelPreviousCall, request_config)
		{
			let method = 'delete';
			this.ajax_call(url, method, formData, successCallback, failCallback, cancelPreviousCall, request_config);
		},
		ajax_get(url, successCallback, failCallback, cancelPreviousCall, request_config) {
			let method = 'get';
			let formData = [];
			this.ajax_call(url, method, formData, successCallback, failCallback, cancelPreviousCall, request_config);
		},
		ajax_call(url, method, formData, successCallback, failCallback, cancelPreviousCall, request_config )
		{
			let self = this;

			let CancelToken = axios.CancelToken;
			let source = CancelToken.source();

			if (self.ajax_xhr != '' && cancelPreviousCall == true)
			{
				try {
					source.cancel('Operation canceled by the user.');
				} catch ($e) { }
			}

			let configs = {};
			configs['cancelToken'] = source.token;
			if (request_config && Object.keys(request_config).length > 0) {
				_.forEach(request_config, (value, key) => {
					configs[key] = value;
				});
			}

			if (method == 'get') {
				self.ajax_xhr = axios[method](url, configs);
			} else if (method == 'delete')
			{
				self.ajax_xhr = axios[method](url, { data: formData }, configs);
			} else {
				self.ajax_xhr = axios[method](url, formData, configs);
			}

			this.$store.commit('setSubmitting', true);

			this.$store.commit('clearNotification');
			this.$store.commit('clearValidationError');
			this.$store.commit('clearError');

			self.ajax_xhr.then((response) => {
				self.ajax_xhr = '';
				if (typeof response.data == 'string') {
					let response_msg = response.data;
					let is_debug_msg = response_msg.includes("<script> Sfdump = window.Sfdump");
					if (is_debug_msg) {
						this.$nextTick(function () {
							this.$root.emit('prompt-modal-message', { modal_type: 'danger', title: 'DEBUG (DD)', message: response.data });
						});
					} else {
						if (!_.isUndefined(successCallback)) {
							successCallback(response);
						}
					}
				} else {
					if (!_.isUndefined(successCallback)) {
						successCallback(response);
					}
				}
                self.$store.commit('setSubmitting', false);
			})
			self.ajax_xhr.catch((error) => {
				self.ajax_xhr = '';
				self.$store.commit('setSubmitting', false);
				if (typeof error.Cancel == 'undefined' || !cancelPreviousCall)
				{
					if (!_.isUndefined(failCallback)) {
						if (error.response.status == '419') {
							if (_.isUndefined(error.response.data.msg) && !_.isUndefined(error.response.data.message))
							{
								this.$set(error.response.data, 'msg', error.response.data.message)
							}
						}
						failCallback(error);
					}
					self.$nextTick(()=> {
						if (!_.isUndefined(error.response) &&
							!_.isUndefined(error.response.status) &&
							error.response.status == '422') {
							if (!_.isUndefined(document.getElementsByClassName('invalid-feedback')[0])) {
								document.getElementsByClassName('invalid-feedback')[0].parentElement.scrollIntoView();
							}
						} else {
							this.$nextTick(function () {
								$('#back-to-top').click();
							});
						}
					})
				}
			});
		},
		printElement(elementId) {
			this.$htmlToPaper(elementId);
		},
		retrieveUserPickerSelectedUsers() {
			let thisSelectedUsers = null;
			window.eventHub.$on('account-retrieve-selected-user', (selected_users) => {
				thisSelectedUsers = selected_users;
			});
			window.eventHub.$emit('retrieve-selected-user', 'account-retrieve-selected-user');
			window.eventHub.$off('account-retrieve-selected-user');
			return thisSelectedUsers;
		},
		blobDownload(data, filename) {
			if (!data) {
				return
			}
			let url = window.URL.createObjectURL(new Blob([data]))
			let link = document.createElement('a');
			link.style.display = 'none';
			link.href = url;
			link.setAttribute('download', filename);
			document.body.appendChild(link);
			link.click();
		},
		blobInlineView(data, filename) {
			if (!data) {
				return
			}
			const file = new Blob([data], {type: 'application/pdf'});
			let url = window.URL.createObjectURL(file)
			window.open(url);
		},
		retrieveUserPickerSelectedUsersWithParam() {
			let pickerParams = {};
			window.eventHub.$on('account-retrieve-selected-user-with-param', (parameter) => {
				pickerParams = parameter;
			});
			window.eventHub.$emit('retrieve-selected-user-with-param', 'account-retrieve-selected-user-with-param');
			window.eventHub.$off('account-retrieve-selected-user-with-param');
			return pickerParams;
		},
		promptModalMessage(parameters) {
			let self = this;
			if (!_.isUndefined(parameters.modal_type) && !_.isNull(parameters.modal_type))
			{
				self.$root.modal_message_parameters.modal_type = parameters.modal_type;
			}
			self.$root.modal_message_parameters.modal_title = parameters.title;
			if (!_.isUndefined(parameters.title_text_color) && !_.isNull(parameters.title_text_color))
			{
				self.$root.modal_message_parameters.modal_title_text_color = parameters.title_text_color;
			}
			self.$root.modal_message_parameters.modal_message = parameters.message;

			self.$root.$emit('bv::hide::modal');

			self.$root.prompt_message_modal = true;

		},
		redirect(url) {
			window.location.href = url;
		},
		ajaxSequenceGetRequest(param, disable_sequence_request = false) {
			let self = this;
			self.$root.ajax_sequence_queue_get_records.push(param);

			if ((disable_sequence_request || !self.$root.ajax_sequence_submitting) &&
				_.size(self.$root.ajax_sequence_queue_get_records) > 0) {

				self.$root.ajax_sequence_submitting = true;
				self.$store.commit('setSubmitting', true);

				self.ajaxSequenceGetRequestCall();
			}
		},
		ajaxSequenceGetRequestCall() {
			let self = this;
			let current_query_arr = _.pullAt(self.$root.ajax_sequence_queue_get_records, [0]);
			let current_query = current_query_arr[0];
			let sequenceSuccessCallback = (response) => {
				if (!_.isUndefined(current_query.request_success_callback)) {
					let queue_success = current_query.request_success_callback;
					queue_success(response);
				}
				if (_.size(self.$root.ajax_sequence_queue_get_records) > 0) {
					this.ajaxSequenceGetRequestCall();
				} else {
					self.$root.ajax_sequence_submitting = false;
					self.$store.commit('setSubmitting', false);
				}
			};
			let sequenceFailCallback = (error) => {
				if (!_.isUndefined(current_query.request_fail_callback)) {
					let queue_failed = current_query.request_fail_callback;
					queue_failed(error);
				}
				if (_.size(self.$root.ajax_sequence_queue_get_records) > 0) {
					this.ajaxSequenceGetRequestCall();
				} else {
					self.$root.ajax_sequence_submitting = false;
					self.$store.commit('setSubmitting', false);
				}
			};
			self.$root.ajax_sequence_submitting = true;
			self.$store.commit('setSubmitting', true);
			this.ajax_get(current_query.request_url, sequenceSuccessCallback, sequenceFailCallback);
		},
		ajaxSequencePostRequest(param, disable_sequence_request = false) {
			let self = this;
			self.$root.ajax_sequence_queue_post_records.push(param);

			if ((disable_sequence_request || !self.$root.ajax_sequence_submitting) &&
				_.size(self.$root.ajax_sequence_queue_post_records) > 0) {

				self.$root.ajax_sequence_submitting = true;
				self.$store.commit('setSubmitting', true);

				self.ajaxSequencePostRequestCall();
			}
		},
		ajaxSequencePostRequestCall() {
			let self = this;
			let current_query_arr = _.pullAt(self.$root.ajax_sequence_queue_post_records, [0]);
			let current_query = current_query_arr[0];
			let sequenceSuccessCallback = (response) => {
				if (!_.isUndefined(current_query.request_success_callback)) {
					let queue_success = current_query.request_success_callback;
					queue_success(response);
				}
				if (_.size(self.$root.ajax_sequence_queue_post_records) > 0) {
					this.ajaxSequencePostRequestCall();
				} else {
					self.$root.ajax_sequence_submitting = false;
					self.$store.commit('setSubmitting', false);
				}
			};
			let sequenceFailCallback = (error) => {
				if (!_.isUndefined(current_query.request_fail_callback)) {
					let queue_failed = current_query.request_fail_callback;
					queue_failed(error);
				}
				if (_.size(self.$root.ajax_sequence_queue_post_records) > 0) {
					this.ajaxSequencePostRequestCall();
				} else {
					self.$root.ajax_sequence_submitting = false;
					self.$store.commit('setSubmitting', false);
				}
			};
			self.$root.ajax_sequence_submitting = true;
			self.$store.commit('setSubmitting', true);

			let formData = _.isUndefined(current_query.form_data) ? {} : current_query.form_data;
			this.ajax_post(current_query.request_url, formData, sequenceSuccessCallback, sequenceFailCallback);
		},
		backToYearTransition(status, url)
		{
			window.location.href = url;
		},
		setTransitionModuleCompleted(url, step, status)
		{
			let formData = { step: step, value: status};
			let ajaxSuccessCallback = (response) => {
				this.$nextTick(function () {
					// window.location.href = this.redirect_url;
					this.getYearTransitionCompleted();
					this.$store.commit('setRedirectNotification', response.data.msg);
					this.$store.commit('setNotificationType', 'success');
				});
			};
			let ajaxFailCallback = (error) => {
				if (error.response.status == '422') {
					this.$store.commit('setValidationError', error.response.data.errors)
				} else {
					this.$store.commit('setError', error.response.data.msg)
				}
			};
			this.$root.ajax_call(url, 'post', formData, ajaxSuccessCallback, ajaxFailCallback, true);

		},
		getYearTransitionCompleted()
		{
			let url = "/system-management/year-transition/transition-management/complete-status";
			let formData = {};
			let ajaxSuccessCallback = (response) => {
				this.$nextTick(function () {
					this.year_transition_status.year_enabled = response.data.promotion_year_id ? true : false;
					this.year_transition_status.next_term = response.data.next_term;
					this.year_transition_status.next_class = response.data.next_class;
					this.year_transition_status.next_student_promote = response.data.next_student_promote;
					this.year_transition_status.next_new_student = response.data.next_new_student;
					this.year_transition_status.next_new_staff = response.data.next_new_staff;
					this.year_transition_status.next_staff_position = response.data.next_staff_position;
					this.year_transition_status.next_staff_attendance = response.data.next_staff_attendance;
					this.year_transition_status.next_year_calendar_event = response.data.next_year_calendar_event;
					this.year_transition_status.next_year_application_fee_setting = response.data.next_year_application_fee_setting;
					this.year_transition_status.next_year_admission_fee_setting = response.data.next_year_admission_fee_setting;
					this.year_transition_status.next_new_tuition = response.data.next_new_tuition;
					this.year_transition_status.next_student_important_document = response.data.next_student_important_document;
					this.$store.commit('setRedirectNotification', response.data.msg);
					this.$store.commit('setNotificationType', 'success');
					this.$store.commit('setSubmitting', false);
				});
			};
			let ajaxFailCallback = (error) => {
				if (error.response.status == '422') {
					this.$store.commit('setValidationError', error.response.data.errors)
				} else {
					this.$store.commit('setError', error.response.data.msg)
				}
				this.$store.commit('setSubmitting', false);
			};

			this.$store.commit('setSubmitting', true);
			this.$root.ajax_call(url, 'get', formData, ajaxSuccessCallback, ajaxFailCallback, true);

		},
		showYearTransitionModal()
		{
			this.getYearTransitionCompleted();
			this.show_year_transition_confirm = true;
		},
		faq()
		{
			window.open('/faq');
		}
	},
	beforeCreate(){
		if (window.reset.filter) {
			store.commit('resetFilters')
		}
		if (window.reset.menu) {
			store.commit('setMenuShow', true)
		}
		if(window.reset.table_related_filter) {
			store.commit('resetTableRelatedFilters')
		}
	},
	beforeMount(){
		store.commit('receiveLang');
		window.eventHub.$off('prompt-modal-message', this.promptModalMessage);
		window.eventHub.$off('ajax-sequence-get-request', this.ajaxSequenceGetRequest);
	},
	mounted() {
		this.loaded = true;
		this.$root.$on('bv::dropdown::show', bvEvent => {
			this.$root.disable_template_responsive = true;
		});
		this.$root.$on('bv::dropdown::hide', bvEvent => {
			this.$root.disable_template_responsive = false;
		});

		//for javascript redirect with notification
		if(store.state.redirect_notification) {
			store.commit('setNotification', store.state.redirect_notification);
		}
		store.commit('clearRedirectNotification');

		window.eventHub.$on('prompt-modal-message', this.promptModalMessage);
		window.eventHub.$on('ajax-sequence-get-request', this.ajaxSequenceGetRequest);

		if(this.unique_page_id != null){
			store.commit('setUniquePageId', this.unique_page_id);
		}

        if (window.location.pathname === '/home' && (typeof window.auto_popup_news_modal !== 'undefined' ? (window.auto_popup_news_modal === true || window.auto_popup_news_modal === 'true') : !this.dismiss_new_updates)) {
            this.show_news_modal = true;
        }
	},
	computed: {
		menu_icon() {
			return store.state.menu.show ? '&laquo;' : '&raquo;';
		}
	},
});



// WEBPACK FOOTER //
// ./resources/assets/js/_core2.js